// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_ss-0";